import React, { useState } from "react";
import { toast } from "react-toastify";
import moment from "moment";
import { useTranslation } from "react-i18next";

export default function AvailabilityNotePopup({ onYesClick }) {
  const { t } = useTranslation("mediumSchedule");

  return (
    <div className="confirm-delete-wrapper register-medium">
      <div id="AvailabilityNotePopup" className="modal fade"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
         aria-hidden="true"
     data-backdrop="true"
       
      >
        <div className="modal-dialog modal-dialog-preview">
          <div className="modal-content">
            <div className="modal-body">
              <div className="icon-pop">
                {/* <img src="images/Union-icon.png" alt="Union-icon" /> */}
               
              </div>
              <p className="font-size-20"><b>{t("notePopup.message")}</b></p>
              <div className="confirm-btn-box">

                <div
                  className="register-medium-confirnation"
                  data-dismiss="modal"
                  onClick={onYesClick}
                >
                  {t("notePopup.okay")}
                </div>
                {/* <div
                  className="register-medium-confirnation model-close-btn"
                  onClick={onNoClick}
                  data-dismiss="modal"
                >
                  Past Events
                </div> */}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
